<template>
  <BaseModal ref="modal" v-model="modalShow">
    <form @submit.prevent="onSubmit" class="row">
      <div class="form-group col-12 mb-3">
        <label for="justificacion">Justificación</label>
        <textarea v-model="justification" class="form-control" id="justificacion" rows="3"
          placeholder="Indique los fundamentos de la decisión"></textarea>
      </div>
      <div>

        <button @click.prevent="approve" class="btn btn-success" :disabled="disableForm">
          <b-spinner small v-show="isUploadingForm === true"></b-spinner>
          Aprobar
        </button>
        <button @click.prevent="reject" class="btn btn-danger ms-2" :disabled="disableForm">
          <b-spinner small v-show="isUploadingForm === false"></b-spinner>
          Rechazar
        </button>
      </div>
    </form>
  </BaseModal>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import BaseModal from '@/components/shared/Base-modal.vue';

export default {
  name: 'KarinResolve',

  components: {
    BaseModal
  },

  data() {
    return {
      modalShow: false,
      route: '',
      denunciationId: null,

      justification: null,
      approved: null,

      isUploadingForm: null,
    }
  },

  computed: {
    disableForm() {
      return !this.justification || this.isUploadingForm;
    }
  },

  async mounted() {
    this.$eventBus.$on(EventNames.OpenModalKarinResolve, async (query) => {
      this.denunciationId = query;
      this.justification = null;
      this.modalShow = true;
    });
  },

  methods: {
    ...mapActions(["addKarinDenunciationResolution"]),

    async approve() {
      await this.onSubmit(true);
    },

    async reject() {
      await this.onSubmit(false);
    },

    async onSubmit(isApproved) {
      this.isUploadingForm = isApproved;

      let result = await this.addKarinDenunciationResolution({
        denunciationId: this.denunciationId,
        reason: this.justification,
        approved: isApproved
      })

      if (result.isError) {
        this.$refs.modal.showAlert(result.message, 'danger');
        this.isUploadingForm = null;
        return;
      }

      this.$eventBus.$emit(EventNames.ResolvedKarinDenunciation, {page: 1, pageSize: InitPageSize.KarinDenouncePageSize});
      this.modalShow = false;
      this.$refs.modal.showAlertExternal('La decisión ha sido enviada correctamente', 'success');
      
      this.justification = null;
      this.isUploadingForm = null;
    },
  }
}
</script>
